module.exports = __webpack_public_path__ + "assets/img/3594-pm.svg";